export default __webpack_public_path__ + "static/media/img-11.2dc9b9db.jpg";